import React from "react";
import { useNavigate } from "react-router-dom";

import { LocalStorageKeys, ROUTES } from "@is/constants";
import { LocalStorageService } from "@is/services";

type Props = {
  children: React.ReactElement;
};

function Unregistered({ children }: Props) {
  const deviceId = LocalStorageService.getItem(LocalStorageKeys.DeviceId);
  const navigate = useNavigate();

  if (deviceId) {
    navigate(ROUTES.EntryView);
    return null;
  }

  return children;
}

export default Unregistered;
